/*  ==========================================================================
    PRICE LISTS
    Settings for different types of price lists, needs "bn_js_ratecalc"!

    INFO:
    - Each new price list needs a "template", "config", "preset" and "callback"
      defined here!
    - Follow the naming convention (v1, v2...)
    - Look here to document your new price list and for further explanation:
      "Build/source/hbs/ehotelier/price/README.txt"
    - Simple example:
      ...
        v?: {
            callback: function(container) {
            },
            config: function(boardCode) {
                return {
                    rateplanlabels: [
                        {
                            rateplancode: 'BN_1_3_' + boardCode,
                            rplabel: vars.ts.text.dailyPrice
                        },
                        {
                            rateplancode: 'BN_4_6_' + boardCode,
                            rplabel: vars.ts.text.from + ' 4 ' + vars.ts.text.nights
                        },
                        {
                            rateplancode: 'BN_7_null_' + boardCode,
                            rplabel: vars.ts.text.from + ' 7 ' + vars.ts.text.nights
                        }
                    ],
                    rateplanorder: ['BN_1_3_' + boardCode, 'BN_4_6_' + boardCode, 'BN_7_null_' + boardCode]
                }
            },
            preset: 'groupRateplans',
            template: hbs_price_v?,
        }
    ...
    ========================================================================== */

/*
 * IMPORTS
 */

// node modules imports
import $ from 'jquery';

// local imports
import * as vars from '../../../../globals/variables';
import * as utils from "../../../../utilities/utils";

// hbs imports
import hbs_price_v1 from '../../../../../hbs/ehotelier/price/v1.hbs';
import hbs_price_v2 from '../../../../../hbs/ehotelier/price/v2.hbs';

/*
 * OPTIONS
 */

export const options = {
    v1: {
        callback: function(container) {

            // tab panel
            $(container).find('.bn-tab-panel').each(function () {
                let $tabPanel = $(this);
                utils.tabPanels.initSimpleTabPanel($tabPanel);
            });

        },
        config: function(boardCode) {
            return {
                rateplanlabels: [
                    {
                        rateplancode: 'BN_1_3_' + boardCode,
                        rplabel: vars.ts.text.dailyPrice
                    },
                    {
                        rateplancode: 'BN_4_6_' + boardCode,
                        rplabel: vars.ts.text.from + ' 4 ' + vars.ts.text.nights
                    },
                    {
                        rateplancode: 'BN_7_null_' + boardCode,
                        rplabel: vars.ts.text.from + ' 7 ' + vars.ts.text.nights
                    }
                ],
                rateplanorder: ['BN_1_3_' + boardCode, 'BN_4_6_' + boardCode, 'BN_7_null_' + boardCode]
            }
        },
        preset: 'groupSeasoncategories',
        template: hbs_price_v1,
    },
    v2: {
        callback: function(container) {

            // initialize slider
            $(container).find('.bn-price-list__slider').each(function () {
                let $sliderArrows = $(this).parents('.bn-room-rates:not(.bn-room-rates--sticky)').find('.slick-arrows'),
                    $sliderContainer = $(this),
                    sliderOverrides = {
                        appendArrows: $sliderArrows,
                        arrows: true,
                        asNavFor: '.bn-price-list .bn-price-list__slider',
                        autoplay: false,
                        dots: false,
                        infinite: false,
                        nextArrow: vars.slick_nextArrowV2,
                        prevArrow: vars.slick_prevArrowV2,
                        responsive: [
                            {
                                breakpoint: 1025,
                                settings: {
                                    slidesToShow: 3
                                }
                            },
                            {
                                breakpoint: 769,
                                settings: {
                                    slidesToShow: 2
                                }
                            },
                            {
                                breakpoint: 481,
                                settings: {
                                    slidesToShow: 1
                                }
                            }
                        ],
                        slidesToShow: 4,
                        speed: 250
                    };
                utils.slickCarousel.initPluralSlider($sliderContainer, sliderOverrides);

                // jump back to first slide if a latecomer gets loaded
                setTimeout(function() {
                    $sliderContainer.slick('slickGoTo', 0);
                },250);

            });

        },
        config: function(boardCode) {
            return {
                rateplanlabels: [
                    {
                        rateplancode: 'BN_1_3_' + boardCode,
                        rplabel: vars.ts.text.dailyPrice
                    },
                    {
                        rateplancode: 'BN_4_6_' + boardCode,
                        rplabel: vars.ts.text.from + ' 4 ' + vars.ts.text.nights
                    },
                    {
                        rateplancode: 'BN_7_null_' + boardCode,
                        rplabel: vars.ts.text.from + ' 7 ' + vars.ts.text.nights
                    }
                ],
                rateplanorder: ['BN_1_3_' + boardCode, 'BN_4_6_' + boardCode, 'BN_7_null_' + boardCode]
            }
        },
        preset: 'groupSeasoncategories',
        template: hbs_price_v2,
    }
};


// WEBPACK FOOTER //
// ./source/js/globals/config/ehotelier/lib/price-lists.js